module.exports = __webpack_public_path__ + "img/public.f7bc74d5.svg";